import React from 'react';
import PropTypes from 'prop-types';
import { DialogContent } from '@material-ui/core';

import { getChannelPerformanceLabel } from 'src/data/channel';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { CUSTOM_BUTTON_SIZE, CustomButton } from 'src/components/CustomButton';
import { CustomDialog } from 'src/components/CustomDialog';
import img from './assets/beta-channel.png';
import { useStyles } from './useStyles';

const BETA_FORM_LINK = 'https://forms.monday.com/forms/195c2563905661998f6b21c6bf73e0e1?r=use1';

export const BetaIntegrationPopup = ({ open, onClose, channel }) => {
  const styles = useStyles();

  return (
    <CustomDialog
      className={styles.root}
      open={open}
      onClose={onClose}
      data-testid="BetaIntegrationPopup"
      hideActions
      displayCloseIcon
    >
      <DialogContent className={styles.dialogContent}>
        <img src={img} />
        <CustomTypography className={styles.title}>
          {getChannelPerformanceLabel(channel)} integration is in beta
        </CustomTypography>

        <CustomTypography variant={TYPOGRAPHY_VARIANT.paragraph16}>
          Contact Anyword support for access
        </CustomTypography>
        <CustomButton
          className={styles.button}
          size={CUSTOM_BUTTON_SIZE.large}
          onClick={onClose}
          target="_blank"
          href={BETA_FORM_LINK}
        >
          Contact us
        </CustomButton>
      </DialogContent>
    </CustomDialog>
  );
};

BetaIntegrationPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  channel: PropTypes.string.isRequired,
};
BetaIntegrationPopup.defaultProps = {};
